import { AppHeader } from "@/components/app-header";
import { ChatSidebar } from "@/components/chat-sidebar";
import { ThemeProvider } from "@/components/ThemeProvider";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { getCookie } from "@/lib/utils";
import { Outlet, useNavigate } from "react-router-dom";
import HelpDialog from "@/components/dialogs/HelpDialog";
import { useNewChatShortcut, useHelpShortcut } from "@/hooks/useKeyboardShortcut";
import { useNavigationStore } from "@/stores/navigation-store";

const Layout = () => {
    const defaultOpen = getCookie("sidebar:state") || "true";
    const navigate = useNavigate();
    const { setHelpIsOpen } = useNavigationStore();

    useNewChatShortcut(() => {
        navigate("/");
    });

    useHelpShortcut(() => {
        setHelpIsOpen(true);
    });

    return (
        <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <SidebarProvider defaultOpen={defaultOpen == "true"}>
                <ChatSidebar />
                <SidebarInset>
                    <AppHeader />
                    <Outlet />
                    {/* <ProgressCard className="fixed bottom-3 right-3 w-96" title="In Progress..." description="Embedding" value={100} total={100} /> */}
                </SidebarInset>
                <HelpDialog />
            </SidebarProvider>
            <Toaster richColors closeButton />
        </ThemeProvider>
    );
};

export default Layout;
